if (!customElements.get("variant-swatch-buttons")) {
  customElements.define(
    "variant-swatch-buttons",
    class variantSwatchButtons extends HTMLElement {
      constructor() {
        super();
        this.onColorSwatches();
      }

      onColorSwatches() {
        const variantList = this.getVariantData() || [];
        const swatchButtonList = this.querySelectorAll("color-swatch-variant");
        const colorKey = this.dataset.colorSwatch;
        const result = Object.values(
          variantList.reduce((total, item) => {
            let k = `${item[colorKey]}`;
            const isDiscounted =
              item.compare_at_price != null &&
              item.compare_at_price > item.price;
            const score =
              (item.available ? 4 : 0) +
              (isDiscounted ? 2 : 0) +
              (item.featured_image || item.featured_media ? 1 : 0);

            if (!total[k] || score > total[k].score) {
              total[k] = { ...item, count: 1, score };
            } else {
              total[k].count += 1;
            }
            return total;
          }, {})
        );

        if (swatchButtonList.length > 0) {
          swatchButtonList.forEach((button) => {
            result.forEach((data) => {
              if (data[colorKey] === button.dataset.value) {
                // Colour is set in Liquid from the shared name -> hex map, so we
                // only attach the variant id needed for the click-to-preview.
                button.setAttribute("data-variant-id", `${data.id}`);
              }
            });
          });
        }
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }
    }
  );
}

// Shared "+N" overflow reveal for swatch lists (product cards and PDP).
document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-swatch-overflow-toggle]");
  if (!toggle) return;
  const container = toggle.closest("[data-swatch-overflow]");
  if (!container) return;
  event.preventDefault();
  container.classList.add("is-expanded");
  toggle.setAttribute("hidden", "");
});

if (!customElements.get("color-swatch-variant")) {
  customElements.define(
    "color-swatch-variant",
    class ColorSwatchVariant extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.productHandle = this.dataset.productHandle;
        this.productCard = this.closest(".product-grid-item");

        this.addEventListener("click", this.onClickHandler.bind(this));
      }

      onClickHandler(event) {
        let url = `/products/${this.productHandle}?variant=${this.variantId}&view=colorswatch`;
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateThumbnail(html);
            this.updateTitle(html);
            this.updatePrice(html);
          })
          .catch((e) => {
            console.error(e);
          });
        // Color swatch button active/remove classList
        const colorButtonList = this.productCard.querySelectorAll(
          ".product--color-swatch"
        );
        colorButtonList.forEach((button) => {
          button.classList.remove("checked-color");
        });
        this.classList.add("checked-color");
      }

      updateThumbnail(html) {
        const destination = this.productCard.querySelector(".media").firstChild;
        const source = html.querySelector(".media").firstChild;
        if (source && destination) {
          destination.src = source.src;
          destination.srcset = source.srcset;
        }
        // Keep the card's existing (collection-scoped) URL and only swap the
        // variant param, so changing colour doesn't drop the collection context.
        const links = this.productCard.querySelectorAll(
          ".product__card--link, .product-grid-item__title a"
        );
        links.forEach((link) => {
          const href = link.getAttribute("href");
          if (!href) return;
          const url = new URL(href, window.location.origin);
          if (this.variantId) url.searchParams.set("variant", this.variantId);
          link.setAttribute(
            "href",
            `${url.pathname}${url.search}${url.hash}`
          );
        });
      }

      updateTitle(html) {
        const destination = this.productCard.querySelector(
          ".product-grid-item__title"
        );
        const source = html.querySelector(".product-grid-item__title");

        if (source && destination) destination.innerHTML = source.innerHTML;
      }

      updatePrice(html) {
        const destination = this.productCard.querySelector(".price");
        const source = html.querySelector(".price");
        if (source && destination) destination.innerHTML = source.innerHTML;
      }
    }
  );
}
